<template>
  <div>
    <loading :active="isLoading" :can-cancel="false" :is-full-page="true" />
    <!-- <v-snackbar v-model="snackbar" :multi-line="true" :timeout="6000" :location="'top'" :vertical="false">
      {{ snackbarText }}
      <template v-slot:actions>
        <v-btn color="pink" variant="text" @click="snackbar = false">Close</v-btn>
      </template>
</v-snackbar> -->

    <v-snackbar :timeout="6000" v-model="snackbar" :multi-line="true" :location="'top'" transition="slide-y-transition" :vertical="false" eager>
      {{ snackbarText }}
      <template v-slot:actions>
        <v-btn color="pink" variant="text" @click="snackbar = false">Close</v-btn>
      </template>
    </v-snackbar>

    <v-card>
      <v-card-title>
        <v-layout class="padding_left_20" style="margin-top:10px ;margin-bottom:10px;">
          <v-icon class="text-black">mdi-cog</v-icon>
          <h4 class="text-black">Settings</h4>

        </v-layout>
      </v-card-title>
      <v-card-actions class="v-card-actions_Setting-saveButton">
        <v-btn :ascls="' ta-pendingagreements-save'" :disabled="validateForm()" variant="elevated" elevation="8"
          density="default" rounded="xs" color="success" @click="saveConfig()"
          style="z-index: 1; margin-top: -33px;margin-left: 95%;position: relative;">Save</v-btn>
      </v-card-actions>
    </v-card>

    <v-divider />

    <v-row class="padding_left_20">
      <v-col col="12">
        <v-card>
          <v-divider />
          <v-card-text class="padding_bottom_0">
            <div class="configurationSelect">
              <v-col class="v-col-sm-3_DropDownWidthset" col="12" sm="3" d-flex text-xs-left>
                <label class="subheading" style="margin-bottom: 1%;">
                  <span class="text-black">Select AGRIS email type <span class="text-red">*</span></span> &nbsp;
                  <a :href="documentationUrl" target="_blank" :title="documentationUrlTitle">
                    <v-icon class="text-grey subheading">mdi-help-circle</v-icon>
                  </a>
                </label>
              </v-col>
              <v-col class="v-col-sm-3_DropDownWidthset" col="12" sm="3">
                <v-select :items="emailTypes" variant="outlined" item-title="Name" item-value="Value"
                  v-model="selectedEmailType" class="ta-pendingagreements-emailtypes" />
              </v-col>
            </div>
            <div>
              <v-col class="v-col-sm-3_DropDownWidthset" col="12" sm="3" d-flex text-xs-left>
                <label class="subheading" style="margin-bottom: 1%;">
                  <span class="text-black">Select a status for Printing Quote <span class="text-red">*</span></span>
                  &nbsp;
                  <a :href="documentationUrl" target="_blank" :title="documentationUrlTitle">
                    <v-icon class="text-grey subheading">mdi-help-circle</v-icon>
                  </a>
                </label>
              </v-col>
              <v-col class="v-col-sm-3_DropDownWidthset" col="12" sm="3" d-flex>
                <v-select :items="statusListforPendingQuote" variant="outlined" item-title="Value" item-value="Name"
                  v-model="selectedPendingQuoteStatus" class="ta-pendingagreements-pendingquotestatus" />
              </v-col>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="padding_left_20">
      <v-col col="12" style="padding-bottom: 0px;">
        <v-card>
          <v-card-title class="padding_bottom_20">
            <v-row wrap class="padding_left_20" style="margin-top:1px;">
              <v-col col="3" sm="9" text-xs-left>
                <h3 class="text-black">Print Agreements</h3>
                <p style="color: rgba(0, 0, 0, 0.6);font-size: 16px !important;font-weight: 400;">
                  <small>By enabling this feature your team can provide a copy of the booking/prepay to the customer
                    prior
                    to Sales Manager approval.</small>
                </p>
              </v-col>
              <!-- <v-col v-if="statusConfig.Value" col="2" sm="2" text-xs-right>
                  <v-btn :class="'ta-pendingagreements-save'" :disabled="validateForm()" small color="success" @click="saveConfig()">Save</v-btn>
                </v-col> -->
              <v-col col="1" sm="1" text-xs-left>
                <v-switch v-on:update:model-value="onStatusChange()" color="green"
                  style="z-index: 1;margin-right: -28px; margin-top: 28px;"
                  :class="'swtich ' + 'ta-pendingagreements-switch-status'" v-model="statusConfig.Value"
                  v-bind:label="statusConfig.Value ? 'on' : 'off'" />
              </v-col>
            </v-row>
          </v-card-title>
          <v-divider />
          <v-card-text class="padding_bottom_0 " style="height: auto;">
            <!-- <div v-if="statusConfig.Value" class="configurationSelect">
                <v-col col="12" sm="12" d-flex text-xs-left>
                  <label class="subheading" style="margin-bottom: 1%;">
                    <span class="black--text">Select AGRIS email type <span class="red--text">*</span></span> &nbsp;
                    <a :href="documentationUrl" target="_blank" :title="documentationUrlTitle">
                      <v-icon class="grey--text subheading">mdi-help-circle</v-icon>
                    </a>
                  </label>
                </v-col>
                <v-col class="v-col-sm-3_DropDownWidthset" col="12" sm="3" d-flex>
                  <v-select :items="emailTypes" outline item-text="Name" item-value="Value" v-model="selectedEmailType" class="ta-pendingagreements-emailtypes"></v-select>
                </v-col>
              </div> -->

            <div v-if="statusConfig.Value" class="configurationSelect">
              <v-col col="12" sm="12" d-flex text-xs-left>
                <label class="subheading" style="margin-bottom: 1%;">
                  <span class="text-black">Select a status for Pending Booking <span class="text-red">*</span></span>
                  &nbsp;
                  <a :href="documentationUrl" target="_blank" :title="documentationUrlTitle">
                    <v-icon class="text-grey subheading">mdi-help-circle</v-icon>
                  </a>
                </label>
              </v-col>
              <v-col class="v-col-sm-3_DropDownWidthset" col="12" sm="3" d-flex>
                <v-select :items="statusListforPendingBooking" variant="outlined" item-title="Value" item-value="Name"
                  v-model="selectedPendingBookingStatus" class="ta-pendingagreements-pendingbookingstatus" />
              </v-col>
            </div>

            <div v-if="statusConfig.Value" class="configurationSelect">
              <v-col col="12" sm="12" d-flex text-xs-left>
                <label class="subheading" style="margin-bottom: 1%;">
                  <span class="text-black">Select a status for Pending Prepay <span class="text-red">*</span></span>
                  &nbsp;
                  <a :href="documentationUrl" target="_blank" :title="documentationUrlTitle">
                    <v-icon class="text-grey subheading">mdi-help-circle</v-icon>
                  </a>
                </label>
              </v-col>
              <v-col class="v-col-sm-3_DropDownWidthset" col="12" sm="3" d-flex>
                <v-select :items="statusListforPendingPrepay" variant="outlined" item-title="Value" item-value="Name"
                  v-model="selectedPendingPrepayStatus" class="ta-pendingagreements-pendingprepaystatus" />
              </v-col>
            </div>

            <!-- <div v-if="statusConfig.Value" class="configurationSelect">
                <v-col  col="12" sm="12" d-flex text-xs-left>
                  <label class="subheading" style="margin-bottom: 1%;">
                    <span class="black--text">Select a status for Pending Sale Order <span class="red--text">*</span></span> &nbsp;
                    <a :href="documentationUrl" target="_blank" :title="documentationUrlTitle">
                      <v-icon class="grey--text subheading">mdi-help-circle</v-icon>
                    </a>
                  </label>
                </v-col>
                <v-col  class="v-col-sm-3_DropDownWidthset" col="12" sm="3" d-flex>
                  <v-select :items="statusListforPendingSalesOrder" outline item-text="Value" item-value="Name" v-model="selectedPendingSalesOrderStatus" class="ta-pendingagreements-pendingsalesorderstatus"></v-select>
                </v-col>
              </div> -->
            <!-- <div v-if="statusConfig.Value" class="configurationSelect">
                <v-col  col="12" sm="12" d-flex text-xs-left>
                  <label class="subheading" style="margin-bottom: 1%;">
                    <span class="black--text">Select a status for Pending Quote <span class="red--text">*</span></span> &nbsp;
                    <a :href="documentationUrl" target="_blank" :title="documentationUrlTitle">
                      <v-icon class="grey--text subheading">mdi-help-circle</v-icon>
                    </a>
                  </label>
                </v-col>
                <v-col  class="v-col-sm-3_DropDownWidthset" col="12" sm="3" d-flex>
                  <v-select :items="statusListforPendingQuote" outline item-text="Value" item-value="Name" v-model="selectedPendingQuoteStatus" class="ta-pendingagreements-pendingquotestatus"></v-select>
                </v-col>
              </div> -->
          </v-card-text>

          <v-divider />

        </v-card>
      </v-col>
    </v-row>

    <v-row class="padding_left_20">
      <v-col col="12" style="padding-top: 0px;">
        <v-card>
          <v-divider />

          <!-- <div>
                <v-card-title class="padding_bottom_20">
                  <v-row wrap class="padding_left_20" style="margin-top:1px ;margin-bottom:10px;">
                    <v-col col="12" sm="12" d-flex text-xs-left>
                      <label class="subheading" style="margin-bottom: 1%;">
                        <span class="black--text">Signature required <span class="red--text">*</span></span> &nbsp;
                        <p style="color: rgba(0, 0, 0, 0.6);font-size: 16px !important;font-weight: 400;">
                          <small>By enabling this feature Signature will be Required</small>
                        </p>
                      </label>
                    </v-col>
                    <v-col col="1" sm="1" text-xs-left>
                      <v-switch v-on:change="onSignatureChange()" color="green" style="z-index: 1;margin-right: -28px; margin-top: 28px;" :class="'swtich '+'ta-pendingagreements-switch-signatureRequired'" v-model="signatureRequiredConfig.Value" v-bind:label="signatureRequiredConfig.Value?'on':'off'"></v-switch>
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-divider></v-divider>
             </div> -->

          <v-card style="padding: 10px;">
            <v-row no-gutters>
              <v-sheet>
                <v-card-title>
                  <label class="subheading" style="margin-bottom: 1%;">
                    <span class="text-black">Signature required <span class="text-red">*</span></span> &nbsp;
                  </label>
                  <v-switch v-on:update:model-value="onSignatureChange()" color="green"
                    :class="'swtich ' + 'ta-pendingagreements-switch-signatureRequired'"
                    v-model="signatureRequiredConfig.Value" v-bind:label="signatureRequiredConfig.Value ? 'on' : 'off'"
                    style="padding: 2%;" />
                </v-card-title>
                <v-card-text>
                  <p style="color: rgba(0, 0, 0, 0.6);font-size: 16px !important;font-weight: 400;">
                    <small>By enabling this feature Signature will be Required</small>
                  </p>
                </v-card-text>
              </v-sheet>
            </v-row>
          </v-card>

          <div v-if="isProRightsEnable" class="configurationSelect">
            <v-card style="padding: 10px;">
              <v-row no-gutters>
                <v-sheet>
                  <v-card-title>
                    <label class="subheading" style="margin-bottom: 1%;">
                      <span class="text-black">Same Booking number <span class="text-red">*</span></span> &nbsp;
                    </label>
                    <v-switch v-on:update:model-value="onSameBookingNumberChange()" color="green"
                      :class="'swtich ' + 'ta-pendingagreements-switch-SameBookingNumber'"
                      v-model="SameBookingNumberConfig.Value"
                      v-bind:label="SameBookingNumberConfig.Value ? 'on' : 'off'" style="padding: 2%;" />
                  </v-card-title>
                  <v-card-text>
                    <p style="color: rgba(0, 0, 0, 0.6);font-size: 16px !important;font-weight: 400;">
                      <small>By enabling this feature Same Booking number is created</small>
                    </p>
                  </v-card-text>
                </v-sheet>
              </v-row>
            </v-card>
            <!-- <v-row no-gutters >
                  <v-sheet >
                      <v-card-title >
                              <div>
                              <v-row wrap class="padding_left_20" style="margin-top:20px ;margin-bottom:20px;">
                                  <v-col col="12" sm="12" d-flex text-xs-left>
                                    <label class="subheading"  style="margin-bottom: 1%;">
                                      <span class="black--text">Same Booking number <span class="red--text">*</span></span> &nbsp;
                                      <p style="color: rgba(0, 0, 0, 0.6);font-size: 16px !important;font-weight: 400;">
                                        <small>By enabling this feature Same Booking number is created</small>
                                      </p>
                                    </label>
                                  </v-col>
                                </v-row>
                              </div>
                              <div>
                                  <v-layout>
                                    <v-col col="1" sm="1" text-xs-left>
                                      <v-switch v-on:change="onSameBookingNumberChange()" color="green" style="z-index: 1;margin-right: -28px; margin-top:30px; ;" :class="'swtich '+'ta-pendingagreements-switch-SameBookingNumber'" v-model="SameBookingNumberConfig.Value" v-bind:label="SameBookingNumberConfig.Value?'on':'off'"></v-switch>
                                    </v-col>
                                  </v-layout>
                                </div>
                        </v-card-title>
                    </v-sheet>
                  </v-row>
                <v-divider></v-divider> -->
          </div>

          <div>
            <div>
              <v-card-text class="padding_bottom_20" style="margin-top: 10px;margin-bottom: 20px;">
                <div class="configurationSelect">
                  <v-col col="12" sm="12" md="8" d-flex text-xs-left>
                    <label class="subheading" style="margin-bottom: 1%;">
                      <span class="text-black">Button Configuration</span>
                      &nbsp;
                      <p
                        style="color: rgba(0, 0, 0, 0.6);font-size: 16px !important;font-weight: 400;margin-top: 10px;margin-bottom: 25px; ">
                        <small>By Changing the Text fields corresponding button name will change</small>
                      </p>
                      <v-text-field label="Quote" color="primary" variant="underlined" counter maxlength="15"
                        v-on:change="QuoteTextChange()" v-model="Btn_QuoteConfig.Value" />
                      <!-- <v-text-field label="Pending Booking" counter maxlength="15" v-on:change="PendingBookingTextChange()" v-model="Btn_PendingBookingConfig.Value"> </v-text-field> -->
                      <v-text-field label="Booking" color="primary" variant="underlined" counter maxlength="15"
                        v-on:change="BookingTextChange()" v-model="Btn_BookingConfig.Value" />
                      <!-- <v-text-field label="Pending Prepay" counter maxlength="15" v-on:change="PendingPrepayTextChange()" v-model="Btn_PendingPrepayConfig.Value"> </v-text-field> -->
                      <v-text-field label="Prepay" color="primary" variant="underlined" counter maxlength="15"
                        v-on:change="PrepayTextChange()" v-model="Btn_PrepayConfig.Value" />
                    </label>
                  </v-col>
                  <v-col col="12" sm="3" d-flex />
                </div>
              </v-card-text>
            </div>

            <div style="margin-bottom: 20px;">
              <!-- <v-container style="padding: 0px;"> -->
              <v-card style="padding: 0px;">
                <v-row no-gutters>
                  <v-sheet>
                    <v-card-title>
                      <label class="subheading" style="margin-bottom: 1%;">
                        <span class="text-black">Hide/Unhide Quote Button<span class="text-red">*</span></span> &nbsp;
                      </label>
                      <v-switch v-on:update:model-value="onHideQuoteButtonChange()" color="green"
                        :class="'swtich ' + 'ta-pendingagreements-switch-HideQuoteButton'"
                        v-model="HideQuoteButtonConfig.Value"
                        v-bind:label="HideQuoteButtonConfig.Value ? 'Hide' : 'Visible'" style="padding: 2%;" />
                    </v-card-title>
                    <v-card-text>
                      <p style="color: rgba(0, 0, 0, 0.6);font-size: 16px !important;font-weight: 400;">
                        <small>By enabling this feature Quote Button will be hidden from User</small>
                      </p>
                    </v-card-text>
                  </v-sheet>
                </v-row>
              </v-card>
              <!-- </v-container> -->

              <!-- <v-container style="padding: 0px;"> -->
              <v-card style="padding: 0px;">
                <v-row no-gutters>
                  <v-sheet>
                    <v-card-title>
                      <label class="subheading" style="margin-bottom: 1%;">
                        <span class="text-black">Hide/Unhide Prepay Button <span class="text-red">*</span></span> &nbsp;
                      </label>
                      <v-switch v-on:update:model-value="onHidePrepayButtonChange()" color="green"
                        :class="'swtich ' + 'ta-pendingagreements-switch-HidePrepayButton'"
                        v-model="HidePrepayButtonConfig.Value"
                        v-bind:label="HidePrepayButtonConfig.Value ? 'Hide' : 'Visible'" style="padding: 2%;" />
                    </v-card-title>
                    <v-card-text>
                      <p style="color: rgba(0, 0, 0, 0.6);font-size: 16px !important;font-weight: 400;">
                        <small>By enabling this feature Prepay Button will be hidden from User</small>
                      </p>
                    </v-card-text>
                  </v-sheet>
                </v-row>
              </v-card>

              <v-card style="padding: 0px;">
                <v-row no-gutters>
                  <v-sheet>
                    <v-card-title>
                      <label class="subheading" style="margin-bottom: 1%;">
                        <span class="text-black">Hide/Unhide Booking Button <span class="text-red">*</span></span>
                        &nbsp;
                      </label>
                      <v-switch v-on:update:model-value="onHideBookingButtonChange()" color="green"
                        :class="'swtich ' + 'ta-pendingagreements-switch-HideBookingButton'"
                        v-model="HideBookingButtonConfig.Value"
                        v-bind:label="HideBookingButtonConfig.Value ? 'Hide' : 'Visible'" style="padding: 2%;" />
                    </v-card-title>
                    <v-card-text>
                      <p style="color: rgba(0, 0, 0, 0.6);font-size: 16px !important;font-weight: 400;">
                        <small>By enabling this feature Booking Button will be hidden from User</small>
                      </p>
                    </v-card-text>
                  </v-sheet>
                </v-row>
              </v-card>
            </div>

            <v-divider />

          </div>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="padding_left_20">
      <v-col col="12" style="padding-top: 0px;">
        <v-card style="padding: 10px;">
          <template v-slot:title>
            <h3 class="text-black">Remarks Configuration For Booking/Prepay</h3>
            <v-divider />
          </template>

          <template v-slot:text class="padding_bottom_0">
            <v-row>
              <v-col cols="5">
                <v-select label="Select Remarks for Farm and Field" v-model="selectedRemarksForFarmAndField"
                  :items="remarksForFarmAndField" variant="outlined" item-title="title" item-value="id"
                  class="ta-remarksconfig-selectRemarksForFarmAndField"></v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="5">
                <v-select label="Select Remarks for Booking Program" :items="remarksForBookingProgram"
                  variant="outlined" item-title="title" item-value="id" v-model="selectedRemarksForBookingProgram"
                  class="ta-remarksconfig-selectRemarksForBookingProgram"></v-select>
              </v-col>
            </v-row>

            <!-- <v-row>
              <v-col cols="5">
                <v-select label="Select Remarks for Farm and Field" v-model="selectedRemarksForFarmAndField"
                  :items="remarksForBookingProgram" variant="outlined" item-title="title" item-value="id"
                  class="ta-selectRemarksForFarmAndField" @update:modelValue="selectRemarkNumberForFarmAndField($event)"></v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="5">
                <v-select label="Select Remarks for Print Agreement" :items="remarksForPrintAgreement"
                  variant="outlined" item-title="title" item-value="id" v-model="selectedRemarksForBookingProgram"
                  class="ta-remarksconfig-selectRemarksForBookingProgram" @update:modelValue="selectRemarkNumberForBookingProgram($event)"></v-select>
              </v-col>
            </v-row> -->

            <!-- <v-row>
              <v-col cols="5">
                <v-select label="Select Remarks for Print Agreement" :items="remarksForFarmAndField"
                  variant="outlined" item-title="title" item-value="id" v-model="selectRemarksForPrintAgreement"
                  class="ta-remarksconfig-selectRemarksForPrintAgreement"></v-select>
              </v-col>
            </v-row> -->


          </template>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>

import DataService from "@/services/data-service";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import {
  AppSettingConfigurations,
  PendingAgreementConfigurations,
} from "../constants/index";

import CryptoService from '@/services//crypto-services';

const dataService = new DataService();
const cryptoService = new CryptoService();
const CurrentAppSettings = AppSettingConfigurations.PendingAgreements;
// const PendingAgreementConfigurations = {
//   Status: "PendingAgreementStatus",
//   EmailTypes: "EmailTypes",
//   PendingBookingStatus: "PendingBookingStatus",
//   PendingPrepayStatus: "PendingPrepayStatus",
// };
const DefaultDropdownOptions = {
  EmailTypesDefaultOption: "Select email type",
  BookingStatusDefaultOption: "Select booking status",
  PrepayStatusTypesDefaultOption: "Select prepay status",
  SalesOrderStatusTypesDefaultOption: "Select sales order status",
  QuoteStatusTypesDefaultOption: "Select quote status",
};
const ConfigurationNames = {
  SelectedEmailType: "SelectedEmailType",
  SelectedPendingBookingStatus: "SelectedPendingBookingStatus",
  SelectedPendingPrepayStatus: "SelectedPendingPrepayStatus",
  SelectedPendingSalesOrderStatus: "SelectedPendingSalesOrderStatus",
  SelectedPendingQuoteStatus: "SelectedPendingQuoteStatus",
  RemarkNumberForFarmAndField: 'RemarkNumberForFarmAndField',
  RemarkNumberForBookingProgram: 'RemarkNumberForBookingProgram',
};

class AppSettings {
  constructor(_type = CurrentAppSettings, _name = "", _value = "") {
    this.Type = _type;
    this.Name = _name;
    this.Value = _value;
    this.Id = "";
  }
  Id;
  Name;
  Value;
  Type;
}

export default {
  name: "settings",
  data: () => ({
    documentationUrl: "https://culturatech.atlassian.net/wiki/x/AYBmsw/",
    documentationUrlTitle: "For more details view documentation",
    snackbar: false,
    snackbarText: "",
    selectedEmailType: "",
    selectedPendingBookingStatus: "",
    selectedPendingPrepayStatus: "",
    selectedPendingSalesOrderStatus: "",
    selectedPendingQuoteStatus: "",
    statusConfig: new AppSettings(
      CurrentAppSettings,
      PendingAgreementConfigurations.Status,
      false
    ),
    emailTypeConfig: new AppSettings(
      CurrentAppSettings,
      DefaultDropdownOptions.EmailTypesDefaultOption,
      ""
    ),
    statusForPendingBookingConfig: new AppSettings(
      CurrentAppSettings,
      "",
      DefaultDropdownOptions.BookingStatusDefaultOption
    ),
    statusForPendingPrepayConfig: new AppSettings(
      CurrentAppSettings,
      "",
      DefaultDropdownOptions.PrepayStatusTypesDefaultOption
    ),
    statusForPendingSalesOrderConfig: new AppSettings(
      CurrentAppSettings,
      "",
      DefaultDropdownOptions.SalesOrderStatusTypesDefaultOption
    ),
    statusForPendingQuoteConfig: new AppSettings(
      CurrentAppSettings,
      "",
      DefaultDropdownOptions.QuoteStatusTypesDefaultOption
    ),
    signatureRequiredConfig: new AppSettings(
      CurrentAppSettings,
      PendingAgreementConfigurations.SignatureRequired,
      false
    ),

    SameBookingNumberConfig: new AppSettings(
      CurrentAppSettings,
      PendingAgreementConfigurations.SameBookingNumber,
      false
    ),

    Btn_QuoteConfig: new AppSettings(
      CurrentAppSettings,
      PendingAgreementConfigurations.ButtonQuote,
      ""
    ),
    Btn_PendingBookingConfig: new AppSettings(
      CurrentAppSettings,
      PendingAgreementConfigurations.ButtonPendingBooking,
      ""
    ),
    Btn_BookingConfig: new AppSettings(
      CurrentAppSettings,
      PendingAgreementConfigurations.ButtonBooking,
      ""
    ),
    Btn_PendingPrepayConfig: new AppSettings(
      CurrentAppSettings,
      PendingAgreementConfigurations.ButtonPendingPrepay,
      ""
    ),
    Btn_PrepayConfig: new AppSettings(
      CurrentAppSettings,
      PendingAgreementConfigurations.ButtonPrepay,
      ""
    ),
    HideQuoteButtonConfig: new AppSettings(
      CurrentAppSettings,
      PendingAgreementConfigurations.HideQuoteButton,
      false
    ),
    HidePrepayButtonConfig: new AppSettings(
      CurrentAppSettings,
      PendingAgreementConfigurations.HidePrepayButton,
      false
    ),
    HideBookingButtonConfig: new AppSettings(
      CurrentAppSettings,
      PendingAgreementConfigurations.HideBookingButton,
      false
    ),

    RemarkNumberForBookingProgram: new AppSettings(
      CurrentAppSettings,
      PendingAgreementConfigurations.RemarkNumberForBookingProgram,
      false
    ),

    RemarkNumberForFarmAndField: new AppSettings(
      CurrentAppSettings,
      PendingAgreementConfigurations.RemarkNumberForFarmAndField,
      false
    ),


    emailTypes: [],
    statusListforPendingBooking: [],
    statusListforPendingPrepay: [],
    statusListforPendingSalesOrder: [],
    statusListforPendingQuote: [],
    isLoading: false,
    isProRightsEnable: false,


    bookingPrepayRemarks: [],
    remarksForBookingProgram: [],
    remarksForPrintAgreement: [],
    remarksForFarmAndField: [],

    selectedRemarksForFarmAndField: null,
    selectedRemarksForBookingProgram: null,
    selectedRemarksForPrintAgreement: null,


  }),
  created() {
    this.initilize();
  },
  components: {
    Loading,
  },
  methods: {
    async initilize() {
      this.isLoading = true;
      this.bookingPrepayRemarks = [
        {
          id: "04",
          title: "Remarks 04"
        },
        {
          id: "05",
          title: "Remarks 05"
        }
        // ,{
        //   id: "06",
        //   title: "Remarks 06"
        // },
      ];

      this.remarksForBookingProgram = this.bookingPrepayRemarks;
      this.remarksForFarmAndField = this.bookingPrepayRemarks;
      this.remarksForPrintAgreement = this.bookingPrepayRemarks;

      this.isProRightsEnable = cryptoService.dencryptString(localStorage.getItem("ProUser")) === 'true' ? true : false;
      this.emailTypes.push({
        Name: this.emailTypeConfig.Name,
        Value: this.emailTypeConfig.Value,
      });
      this.statusListforPendingBooking.push({
        Name: this.statusForPendingBookingConfig.Name,
        Value: this.statusForPendingBookingConfig.Value,
      });
      this.statusListforPendingPrepay.push({
        Name: this.statusForPendingPrepayConfig.Name,
        Value: this.statusForPendingPrepayConfig.Value,
      });
      this.statusListforPendingSalesOrder.push({
        Name: this.statusForPendingSalesOrderConfig.Name,
        Value: this.statusForPendingSalesOrderConfig.Value,
      });
      this.statusListforPendingQuote.push({
        Name: this.statusForPendingQuoteConfig.Name,
        Value: this.statusForPendingQuoteConfig.Value,
      });
      await this.getEmailTypesFromAgris();
      await this.getStatusListFromAgris();
      await this.getAppSettings();
    },
    async getEmailTypesFromAgris() {
      try {
        let response = await dataService.GetEmailTypesFromAgris();
        if (response && response.length) {
          response.forEach((item) => {
            let obj = {};
            obj.Name = `${item.Code} - ${item.Description}`;
            obj.Value = `${item.Code} - ${item.Description}`;
            this.emailTypes.push(obj);
          });
        }
      } catch (ex) {
        this.isLoading = false;
        this.snackbar = true;
        this.snackbarText = "Failed to fetch email types list from AGRIS";
      }
    },
    async getStatusListFromAgris() {
      try {
        let response = await dataService.GetPackageSetupToken("INV");
        if (response) {
          this.getOrderStatus(Object.create(response));
        }
      } catch (ex) {
        this.isLoading = false;
        this.snackbar = true;
        this.snackbarText = "Failed to fetch status list from AGRIS";
      }
    },
    getOrderStatus(data) {
      data
        .filter((d) => d.SetupToken.includes("ORDER_PENDING_REASON"))
        .forEach((status, i) => {
          let count = i + 1;
          if (status.SetupToken.includes(count)) {
            let obj = {
              Name: count.toString(),
              Value: `${count.toString()} - ${status.SetupValue}`,
            };
            this.statusListforPendingBooking.push(obj);
            this.statusListforPendingPrepay.push(obj);
            this.statusListforPendingSalesOrder.push(obj);
            this.statusListforPendingQuote.push(obj);
          }
        });
    },
    async getAppSettings() {
      try {
        let response = await dataService.GetAppSettingsByType(
          CurrentAppSettings
        );

        if (response && response.length) {
          Object.assign(
            this.statusConfig,
            response.find(
              (x) => x.Name == PendingAgreementConfigurations.Status
            )
          );
          this.statusConfig.Value = JSON.parse(this.statusConfig.Value);

          Object.assign(
            this.emailTypeConfig,
            response.find((x) => x.Name == ConfigurationNames.SelectedEmailType)
          );
          if (
            this.emailTypeConfig.Name == ConfigurationNames.SelectedEmailType
          ) {
            this.selectedEmailType = this.emailTypeConfig.Value;
          }

          Object.assign(
            this.statusForPendingBookingConfig,
            response.find(
              (x) => x.Name == ConfigurationNames.SelectedPendingBookingStatus
            )
          );
          if (
            this.statusForPendingBookingConfig.Name ==
            ConfigurationNames.SelectedPendingBookingStatus
          ) {
            this.selectedPendingBookingStatus =
              this.statusForPendingBookingConfig.Value;
          }

          Object.assign(
            this.statusForPendingPrepayConfig,
            response.find(
              (x) => x.Name == ConfigurationNames.SelectedPendingPrepayStatus
            )
          );
          if (
            this.statusForPendingPrepayConfig.Name ==
            ConfigurationNames.SelectedPendingPrepayStatus
          ) {
            this.selectedPendingPrepayStatus =
              this.statusForPendingPrepayConfig.Value;
          }

          Object.assign(
            this.statusForPendingSalesOrderConfig,
            response.find(
              (x) =>
                x.Name == ConfigurationNames.SelectedPendingSalesOrderStatus
            )
          );
          if (
            this.statusForPendingSalesOrderConfig.Name ==
            ConfigurationNames.SelectedPendingSalesOrderStatus
          ) {
            this.selectedPendingSalesOrderStatus =
              this.statusForPendingSalesOrderConfig.Value;
          }

          Object.assign(
            this.statusForPendingQuoteConfig,
            response.find(
              (x) => x.Name == ConfigurationNames.SelectedPendingQuoteStatus
            )
          );
          if (
            this.statusForPendingQuoteConfig.Name ==
            ConfigurationNames.SelectedPendingQuoteStatus
          ) {
            this.selectedPendingQuoteStatus =
              this.statusForPendingQuoteConfig.Value;
          }

          Object.assign(
            this.signatureRequiredConfig,
            response.find(
              (x) => x.Name == PendingAgreementConfigurations.SignatureRequired
            )
          );
          this.signatureRequiredConfig.Value = JSON.parse(
            this.signatureRequiredConfig.Value
          );

          Object.assign(
            this.SameBookingNumberConfig,
            response.find(
              (x) => x.Name == PendingAgreementConfigurations.SameBookingNumber
            )
          );
          this.SameBookingNumberConfig.Value = JSON.parse(
            this.SameBookingNumberConfig.Value
          );


          Object.assign(
            this.Btn_QuoteConfig,
            response.find(
              (x) => x.Name == PendingAgreementConfigurations.ButtonQuote
            )
          );
          this.Btn_QuoteConfig.Value = this.Btn_QuoteConfig.Value;

          Object.assign(
            this.Btn_PendingBookingConfig,
            response.find(
              (x) =>
                x.Name == PendingAgreementConfigurations.ButtonPendingBooking
            )
          );
          this.Btn_PendingBookingConfig.Value =
            this.Btn_PendingBookingConfig.Value;

          Object.assign(
            this.Btn_BookingConfig,
            response.find(
              (x) => x.Name == PendingAgreementConfigurations.ButtonBooking
            )
          );
          this.Btn_BookingConfig.Value = this.Btn_BookingConfig.Value;

          Object.assign(
            this.Btn_PendingPrepayConfig,
            response.find(
              (x) =>
                x.Name == PendingAgreementConfigurations.ButtonPendingPrepay
            )
          );
          this.Btn_PendingPrepayConfig.Value =
            this.Btn_PendingPrepayConfig.Value;

          Object.assign(
            this.Btn_PrepayConfig,
            response.find(
              (x) => x.Name == PendingAgreementConfigurations.ButtonPrepay
            )
          );
          this.Btn_PrepayConfig.Value = this.Btn_PrepayConfig.Value;

          Object.assign(
            this.HideQuoteButtonConfig,
            response.find(
              (x) => x.Name == PendingAgreementConfigurations.HideQuoteButton
            )
          );
          this.HideQuoteButtonConfig.Value = JSON.parse(
            this.HideQuoteButtonConfig.Value
          );

          Object.assign(
            this.HideBookingButtonConfig,
            response.find(
              (x) => x.Name == PendingAgreementConfigurations.HideBookingButton
            )
          );
          this.HideBookingButtonConfig.Value = JSON.parse(
            this.HideBookingButtonConfig.Value
          );

          Object.assign(
            this.HidePrepayButtonConfig,
            response.find(
              (x) => x.Name == PendingAgreementConfigurations.HidePrepayButton
            )
          );
          this.HidePrepayButtonConfig.Value = JSON.parse(
            this.HidePrepayButtonConfig.Value
          );


          Object.assign(
            this.RemarkNumberForBookingProgram,
            response.find(
              (x) => x.Name == PendingAgreementConfigurations.RemarkNumberForBookingProgram
            )
          );
          this.selectedRemarksForBookingProgram = this.RemarkNumberForBookingProgram.Value;


          Object.assign(
            this.RemarkNumberForFarmAndField,
            response.find(
              (x) => x.Name == PendingAgreementConfigurations.RemarkNumberForFarmAndField
            )
          );
          this.selectedRemarksForFarmAndField = this.RemarkNumberForFarmAndField.Value
         
        }
        this.isLoading = false;
      } catch (ex) {
        console.log(ex);
        this.isLoading = false;
        this.snackbar = true;
        this.snackbarText = "Failed to fetch saved settings";
      }
    },
    saveConfig() {
      this.isLoading = true;
      let data = [];

      this.emailTypeConfig.Value = this.selectedEmailType;
      this.emailTypeConfig.Name = ConfigurationNames.SelectedEmailType;
      data.push(this.emailTypeConfig);

      this.statusForPendingBookingConfig.Value =
        this.selectedPendingBookingStatus;
      this.statusForPendingBookingConfig.Name =
        ConfigurationNames.SelectedPendingBookingStatus;
      data.push(this.statusForPendingBookingConfig);

      this.statusForPendingPrepayConfig.Value =
        this.selectedPendingPrepayStatus;
      this.statusForPendingPrepayConfig.Name =
        ConfigurationNames.SelectedPendingPrepayStatus;
      data.push(this.statusForPendingPrepayConfig);

      this.statusForPendingSalesOrderConfig.Value =
        this.selectedPendingSalesOrderStatus;
      this.statusForPendingSalesOrderConfig.Name =
        ConfigurationNames.SelectedPendingSalesOrderStatus;
      data.push(this.statusForPendingSalesOrderConfig);

      this.statusForPendingQuoteConfig.Value = this.selectedPendingQuoteStatus;
      this.statusForPendingQuoteConfig.Name =
        ConfigurationNames.SelectedPendingQuoteStatus;
      data.push(this.statusForPendingQuoteConfig);

      this.RemarkNumberForBookingProgram.Value = this.selectedRemarksForBookingProgram;
      this.remarksForBookingProgram.Name =
        ConfigurationNames.RemarkNumberForBookingProgram;
      data.push(this.RemarkNumberForBookingProgram);

      this.RemarkNumberForFarmAndField.Value = this.selectedRemarksForFarmAndField;
      this.RemarkNumberForFarmAndField.Name =
        ConfigurationNames.RemarkNumberForFarmAndField;
      data.push(this.RemarkNumberForFarmAndField);

      console.log(JSON.stringify(data));
      if (this.RemarkNumberForFarmAndField.Value == this.RemarkNumberForBookingProgram.Value) {
        this.snackbar = true;
        this.snackbarText = "Please select different remarks numbers for Farm & Fields and Booking program values";
        this.isLoading = false;
        return;
      }
      this.saveAppSettings(data);
    },
    onStatusChange() {
      this.isLoading = true;
      let data = [];
      data.push(this.statusConfig);
      let done =
        this.statusConfig.Value == true
          ? "Setting has disabled now"
          : "Setting has enabled now";
      this.saveAppSettings(data, done);
    },

    onSignatureChange() {
      debugger;
      this.isLoading = true;
      let data = [];
      data.push(this.signatureRequiredConfig);
      let done =
        this.signatureRequiredConfig.Value == true
          ? "Signature is Optional now"
          : "Signature is Required now";
      this.saveAppSettings(data, done);
    },

    onSameBookingNumberChange() {

      this.isLoading = true;
      let data = [];
      data.push(this.SameBookingNumberConfig);
      let done =
        this.SameBookingNumberConfig.Value == true
          ? "Same Booking Number Turned OFF"
          : "Same Booking Number Turned ON";
      localStorage.setItem("isSameNumber", this.SameBookingNumberConfig.Value);
      this.saveAppSettings(data, done);
    },

    onHideQuoteButtonChange() {
      this.isLoading = true;
      let data = [];
      data.push(this.HideQuoteButtonConfig);
      let done =
        this.HideQuoteButtonConfig.Value == true
          ? "Quote Button is visible now"
          : "Quote Button is Hidden now";
      this.saveAppSettings(data, done);
    },

    onHidePrepayButtonChange() {
      this.isLoading = true;
      let data = [];
      data.push(this.HidePrepayButtonConfig);
      let done =
        this.HidePrepayButtonConfig.Value == true
          ? "Prepay Button is visible now"
          : "Prepay Button is Hidden now";
      this.saveAppSettings(data, done);
    },

    onHideBookingButtonChange() {
      this.isLoading = true;
      let data = [];
      data.push(this.HideBookingButtonConfig);
      let done =
        this.HideBookingButtonConfig.Value == true
          ? "Booking Button is visible now"
          : "Booking Button is Hidden now";
      this.saveAppSettings(data, done);
    },

    QuoteTextChange() {
      this.isLoading = true;
      let data = [];
      data.push(this.Btn_QuoteConfig);
      let done =
        this.Btn_QuoteConfig.Value === ""
          ? "Field is empty."
          : "Field is Saved";

      // let a=  PendingAgreementConfigurations.ButtonQuote;
      this.saveAppSettings(data, done);
    },
    PendingBookingTextChange() {
      this.isLoading = true;
      let data = [];
      data.push(this.Btn_PendingBookingConfig);
      let done =
        this.Btn_PendingBookingConfig.Value === ""
          ? "Field is empty."
          : "Field is Saved";

      //let a=  PendingAgreementConfigurations.ButtonPendingBooking;
      this.saveAppSettings(data, done);
    },
    BookingTextChange() {
      this.isLoading = true;
      let data = [];

      data.push(this.Btn_BookingConfig);
      let done =
        this.Btn_BookingConfig.Value === ""
          ? "Field is empty."
          : "Field is Saved";
      //let a=  PendingAgreementConfigurations.ButtonBooking;
      this.saveAppSettings(data, done);
    },
    PendingPrepayTextChange() {
      this.isLoading = true;
      let data = [];

      data.push(this.Btn_PendingPrepayConfig);
      let done =
        this.Btn_PendingPrepayConfig.Value === ""
          ? "Field is empty."
          : "Field is Saved";

      //let a=  PendingAgreementConfigurations.ButtonPendingPrepay;
      this.saveAppSettings(data, done);
    },
    PrepayTextChange() {
      this.isLoading = true;
      let data = [];

      data.push(this.Btn_PrepayConfig);
      let done =
        this.Btn_PrepayConfig.Value === ""
          ? "Field is empty."
          : "Field is Saved";

      //let a=  PendingAgreementConfigurations.ButtonPrepay;
      this.saveAppSettings(data, done);
    },

    selectRemarkNumberForBookingProgram($event) {
      // this.isLoading = true;
      // let data = [];
      // data.push(this.RemarkNumberForBookingProgram);
      // let done = "Remarks number for Booking Program is set"
      // this.saveAppSettings(data, done);
    },

    selectRemarkNumberForFarmAndField($event) {
      // this.isLoading = true;
      // let data = [];
      // data.push(this.RemarkNumberForFarmAndField);
      // let done = "Remarks number for Farm and Field is set"
      // this.saveAppSettings(data, done);
    },

    async saveAppSettings(data, msg = "") {
      // console.log("data =>", data);
      // console.log("msg =>", msg);
      try {
        await dataService.SaveAppSettings(data);
        this.snackbar = true;
        this.snackbarText = msg ? msg : "Settings saved successfully";
        this.isLoading = false;
      } catch (ex) {
        this.snackbar = true;
        this.snackbarText = "Settings saved failed";
        this.isLoading = false;
      }
    },
    validateForm() {
      if (this.statusConfig.Name == "") return true;
      if (this.selectedEmailType == "") return true;
      if (this.statusConfig.Value) {
        if (this.selectedPendingBookingStatus == "") return true;
        if (this.selectedPendingPrepayStatus == "") return true;
      }
      // if (this.selectedPendingSalesOrderStatus == "") return true;
      if (this.selectedPendingQuoteStatus == "") return true;
      return false;
    },

  },
};
</script>

<style>
a {
  text-decoration: none;
}

.v-select-list>.v-list {
  height: 300px !important;
}

.v-select.v-text-field--enclosed:not(.v-text-field--single-line):not(.v-text-field--outlined) .v-select__selections {
  padding-top: 5px !important;
}

.v-text-field.v-text-field--enclosed .v-input__prepend-outer,
.v-text-field.v-text-field--enclosed .v-input__prepend-inner,
.v-text-field.v-text-field--enclosed .v-input__append-inner,
.v-text-field.v-text-field--enclosed .v-input__append-outer {
  margin-top: 12px;
}

.theme--light.v-text-field--outlined>.v-input__control>.v-input__slot {
  border-color: #bcbcbc;
}

.v-text-field--box>.v-input__control>.v-input__slot,
.v-text-field--full-width>.v-input__control>.v-input__slot,
.v-text-field--outlined>.v-input__control>.v-input__slot {
  min-height: 45px;
}

.subheading {
  text-align: left;
  font-size: 15px;
  font-weight: 500;
}

.padding_left_20 {
  padding-left: 0px !important;
}

.padding_10 {
  padding: 10px;
}

.v-list {
  height: 400px;
  overflow-y: auto;
}

.text_right {
  text-align: right;
}

.position_right {
  right: 125px;
  position: absolute;
  top: 3px;
}

.v-expansion-panel__header {
  background-color: white;
}

.swtich {
  position: absolute;
  top: -8px;
  right: 57px;
  z-index: 1000;
}

.padding_bottom_0 {
  padding-bottom: 0px;
}

.v-snack {
  padding-left: 0% !important;
}

.v-col-sm-3_DropDownWidthset {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 25%;
  flex: 0 0 25%;
  max-width: 40% !important;
}

.v-card-actions_Setting-saveButton {
  padding-top: 0;
  height: 15px;
}
</style>
